jQuery(function($){
  var isLoading = false;
  $(window).on('scroll', function(){
    window.requestAnimationFrame(function(){
      if (window.scrollY > window.innerHeight * 0.9 && !isLoading){
        isLoading = true;
        var offset = $('.team').data('offset');
        if (offset < $('.team').data('max')){
          $('.pagination__throbber').addClass('is-active');
          $.ajax({
            url: window.ajaxurl,
            type: "POST",
            data: {
              'action': 'get_team_members',
              'offset': offset,
            }
          }).done(function(response){
            var offset = parseInt($('.team').data('offset'));
            offset += $(response).find('.team__block').length;
            $('.team').data('offset', offset);
            $('.team .sv-g').append(response);
            window.telLinks.init();
            window.App.EquipeMarquage();
            isLoading = false;
            $('.pagination__throbber').removeClass('is-active');
          });
        }
      }
    });
  });
});


